<template>
  <v-toolbar id="core-toolbar" app flat prominent style="background: #eee;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>
    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-select
          v-if="this.$store.state.vendors.length > 1"
          v-model="vid"
          :items="this.$store.state.vendors"
          item-text="app_name"
          item-value="id"
          label="Select Vendor"
          single-line
          hide-details
          style="width:200px;"
          color="primary"
          outline
          small
        />
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          open-on-hover
          transition="slide-y-transition"
        >
          <span v-ripple slot="activator" class="toolbar-items">
            <v-avatar v-if="$store.state.user.data.photoURL" size="20">
              <img :src="$store.state.user.data.photoURL" />
            </v-avatar>
            <v-icon v-else color="tertiary">
              mdi-account
            </v-icon>
            {{ $store.state.user.data.displayName }}
            <v-icon>mdi-chevron-down</v-icon>
          </span>
          <v-card width="300">
            <v-card-title>
              <v-avatar slot="offset" class="mx-auto d-block" size="75">
                <img
                  :src="
                    $store.state.user.data.photoURL
                      ? $store.state.user.data.photoURL
                      : 'user.png'
                  "
                />
              </v-avatar>
            </v-card-title>
            <v-card-text class="text-xs-center" style="padding-top:0px;">
              <v-subheader style="justify-content:center;">
                Admin
              </v-subheader>
              <span class="title">{{
                $store.state.user.data.displayName
              }}</span>
              <p class="card-description font-weight-light">
                {{ $store.state.user.data.phoneNumber }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn small color="danger" dark @click="logout()">
                Logout
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapMutations } from 'vuex';
import fb from '../../db';
export default {
  data: () => ({
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      "You're now a friend with Andrew",
      'Another Notification',
      'Another One',
    ],
    title: null,
    responsive: false,
  }),
  computed: {
    vid: {
      set(vid) {
        window.localStorage.vid = vid;
        this.$store.dispatch('selectVid', vid);
      },
      get() {
        return this.$store.state.vid;
      },
    },
  },
  watch: {
    $route(val) {
      this.title = val.name;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    logout() {
      fb.auth().signOut();
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
